import { Component } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';
import { SeoService } from '@wdpr/ra-angular-seo-metadata';
import { ConfigService } from '@app/core/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { GeoLocationInfo } from './services/geolocation/geolocation.info';
import { TranslateService } from '@ngx-translate/core';
import { HomepageAnalyticsService } from '@app/services/analytics/analytics.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public siteId: string;

  title = 'wdpr-pixie-page';
  environment: string;
  seoUrl: string;
  geolocation: GeoLocationInfo;
  affiliations: Object;
  content;

  constructor(
      private logger: LoggerService,
      private seoService: SeoService,
      private configService: ConfigService,
      private homepageAnalyticsService: HomepageAnalyticsService,
      private http: HttpClient,
      private titleService: Title,
      private translate: TranslateService
  ) {
      this.siteId = this.configService.getValue('siteId');
      this.environment = this.configService.getValue('environment');

      this.seoUrl = this.configService.getValue('seoUrl');
      console.log('seoUrl = ', this.seoUrl);
      this.setupSeo();

      this.setupAnalytics();

      this.translate.setDefaultLang('en');
      this.translate.use('en');
  }

  private setupAnalytics() {
      this.homepageAnalyticsService.initAnalytics();
  }

  private setupSeo() {
      this.http.get(this.seoUrl)
          .subscribe((data: any) => {
              this.seoService.setSeoData(data);
              this.titleService.setTitle (data.pageTitle);
          });
  }
}
